import type React from 'react';

import { ProgressBar, Text } from '@change/ds-core-ui';

import { Translate, TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';

import { useContributionCount } from './hooks/useContributionCount';

export const ContributionCount: React.FC = () => {
	const { translate } = useI18n();
	const { completionPercentage, count, localizedCount, localizedGoal } = useContributionCount();

	return (
		<>
			<div className="w-full" data-qa="contributions-thermometer">
				<ProgressBar
					ariaLabel={translate('corgi.psf.promote_or_share.contributions.thermometer.label')}
					percentage={completionPercentage}
				/>
			</div>

			<div className="w-full">
				<div className="sr-only">
					<Text>
						<Translate
							value="corgi.psf.promote_or_share.contributions.count_bar.a11y.count"
							replacements={{ contributionCount: localizedCount }}
						/>
					</Text>
					<Text>
						<Translate
							value="corgi.psf.promote_or_share.contributions.count_bar.a11y.goal"
							replacements={{ nextGoal: localizedGoal }}
						/>
					</Text>
				</div>
				<div className="grid grid-cols-2 grid-rows-2" aria-hidden>
					<Text fontWeight="bold" className="text-typography-accent-primary -mb-2 font-bold" size="large">
						{localizedCount}
					</Text>

					<Text fontWeight="bold" size="large" className="text-typography-weak -mb-2 text-right font-bold">
						{localizedGoal}
					</Text>

					<Text className="text-typography-accent-primary font-semibold" size="x-small">
						<TranslatePlural value="corgi.psf.promote_or_share.contributions.count_bar.count" count={count} />
					</Text>

					<Text className="text-typography-weak text-right font-semibold" size="x-small">
						<Translate value="corgi.psf.promote_or_share.contributions.count_bar.goal" />
					</Text>
				</div>
			</div>
		</>
	);
};
